import { UserGridItem } from "client/Api/UserManagement/userManagement";
import { getUserProfileImageUrl } from "client/Api/UserProfile/service";
import { getComputedDisplayName } from "../AddressBook/common";
import { UserLicense } from "client/Api/FeaturePackages/featurePackageManagement";
import { TagModel } from "client/Components";
import { getUserLicenseName } from "../FeaturePackages/misc";
import { isNotNil } from "client/Misc/utils";
import { doesUserLicenseSatisfyRequiredLicense } from "client/Hooks";

export type UserDisplayItem = {
	readonly model: UserGridItem;
	readonly id: number;
	readonly avatarUrl: string | undefined;
	readonly initials: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly primaryEmail: string | null;
	readonly userPrincipalName: string;
	readonly isActive: boolean;
	readonly deletionDate: Date | null;
	readonly permanentDeletionDate: Date | null;
	readonly isAdmin: boolean;
	readonly isGuest: boolean;
	readonly userLicenseTag: TagModel<UserLicense>;
	readonly isLackingRequiredModule: boolean;
};

export function convertToDisplayItem(
	user: UserGridItem,
	requiredFeatureModel?: UserLicense | null
): UserDisplayItem {
	const avatarUrl: string | undefined = user.pathToImage
		? getUserProfileImageUrl(user.pathToImage)
		: undefined;

	const { initials } = getComputedDisplayName({
		firstName: user.firstName,
		lastName: user.lastName
	});

	const isNotInvoiced: boolean = isNotNil(user.deletionDate) || !user.isActive;

	const userLicenseTag: TagModel<UserLicense> = {
		value: user.userLicense,
		text: getUserLicenseName(user.userLicense),
		isDisabled: isNotInvoiced
	};

	const isLackingRequiredModule: boolean = isNotNil(requiredFeatureModel)
		&& !doesUserLicenseSatisfyRequiredLicense(user.userLicense, requiredFeatureModel);

	return {
		model: user,
		id: user.id,
		avatarUrl,
		initials,
		firstName: user.firstName,
		lastName: user.lastName,
		primaryEmail: user.primaryEmail,
		userPrincipalName: user.userPrincipalName,
		isActive: user.isActive,
		deletionDate: user.deletionDate,
		permanentDeletionDate: user.permanentDeletionDate,
		isAdmin: user.isAdmin,
		isGuest: user.isGuest,
		userLicenseTag,
		isLackingRequiredModule
	};
}
